// extracted by mini-css-extract-plugin
module.exports = {"cont":"LayoutMobileSidebar_cont__1nVCq","title":"LayoutMobileSidebar_title__1Jj61","menu":"LayoutMobileSidebar_menu__2-_KN"};